import React from 'react'
import Icon from '@mui/icons-material/EventAvailableOutlined'
import { SvgIconProps } from '@mui/material/SvgIcon'

const ApproveIcon = (props: SvgIconProps) => <Icon fontSize="small" {...props} />

export default ApproveIcon
export {}
